import ErrorBiundary from './ErrorBoundary';

export default ErrorBiundary;
